import MuiSnackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import { Component } from "react";
import SuccessIcon from "../resources/images/icons-check-circle.svg";
import InfoIcon from "../resources/images/icons-info-circle.svg";
import ErrorIcon from "../resources/images/icons-warning-circle.svg";

export class Snackbar extends Component<any, any> {
  static defaultProps = {
    type: "success",
    duration: 6000
  };

  onClose(e: any, reason: any) {
    const { onClose } = this.props;
    if (onClose && reason === "timeout") onClose(e);
  }

  render() {
    const { type, open, message, duration, onClose, action = <></> } = this.props;

    return (
      <MuiSnackbar
        className={"klayo-snackbar klayo-snackbar_" + type}
        open={open}
        autoHideDuration={duration}
        onClose={this.onClose.bind(this)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Stack spacing={4}>
          <div className='klayo-snackbar_icon'>
            {type === "success" && <SuccessIcon />}
            {type === "error" && <ErrorIcon />}
            {type === "info" && <InfoIcon />}
          </div>
          <div className='klayo-snackbar_text'>{message}</div>

          {action}
        </Stack>
      </MuiSnackbar>
    );
  }
}
